(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
